  <template>
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
            <label for="name" class="col-form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="form.name">
            <v-errors :errors="errorFor('name')"></v-errors>
        </div>

        <div class="mb-3">
            <div class="d_flex_start">
                <button type="button" class="btn btn-primary btn-md  width_100p mr_10" :disabled="lyLoading" @click.prevent="submit">Submit</button>
                <button type="button" class="btn btn-danger btn-md  width_100p" @click.prevent="closeModal">Cancel</button>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
      import {mapGetters} from "vuex";

      export default {
          name: 'ProxmoxSshKeyPairForm',
          props: ['closeModal','loadData', 'editId'],
          data(){
              return {
                lyLoading: false,
                isShowSshDownloadModal: false,
                form: {
                  name: '',
                },
              }
          },
          created() {
          },
        watch: {
          customer() {
            this.loadData();
          }
        },
        computed: {
          ...mapGetters({
            customer: 'auth/getUserInfo',
          }),
        },
          methods: {
            submit() {
              this.allErrors = null;
              this.lyLoading = true;
              
              this.axios.post('/proxmox/generate-ssh-key', this.form)
              .then(({ data }) => {
                  if(data.success){
                      this.showSuccessMsg(data.message);
                      this.closeModal()
                    this.loadData()
                    this.$emit('setCreatedRecord', data.data)
                    this.sshKeyDownloadModalOpen()
                  }else{
                    this.$swal({
                        text: data.message,
                        showCancelButton: false,
                        confirmButtonText: 'Close!',
                        confirmButtonColor: '#dd4b39',
                        reverseButtons: true
                    })
                  }
              })
              .catch((err) => {
                this.allErrors = err.response?.data?.errors
                if (this.allErrors) {
                    this.showFailMsg(err.response?.data?.message);
                  }
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            },
          }
      }
  </script>
  <style scoped>

  </style>
  